import { PATH } from '../../routes';

export const navigationItems = [
	{ name: 'Home', link: PATH.home },
	{ name: 'Projects', link: PATH.projects },
	{ name: 'About', link: PATH.about },
	{ name: 'Skills', link: PATH.skills },
];
